import React, { useState } from 'react';
import Select from '../ui/Select';
import Icon from '../AppIcon';

const DateRangeSelector = () => {
  const [selectedRange, setSelectedRange] = useState('7');
  const [customRange, setCustomRange] = useState({ start: '', end: '' });
  const [showCustom, setShowCustom] = useState(false);

  const presetRanges = [
    { value: '7', label: 'Last 7 days' },
    { value: '30', label: 'Last 30 days' },
    { value: '90', label: 'Last 90 days' },
    { value: 'custom', label: 'Custom range' },
  ];

  const handleRangeChange = (value) => {
    setSelectedRange(value);
    if (value === 'custom') {
      setShowCustom(true);
    } else {
      setShowCustom(false);
      console.log(`Date range changed to: ${value} days`);
    }
  };

  const handleCustomRangeApply = () => {
    if (customRange?.start && customRange?.end) {
      console.log('Custom range applied:', customRange);
      setShowCustom(false);
    }
  };

  return (
    <div className="date-range-selector">
      <Icon name="Calendar" size={20} className="text-muted-foreground" />
      <Select
        options={presetRanges}
        value={selectedRange}
        onChange={handleRangeChange}
        className="w-48"
      />
      {showCustom && (
        <div className="flex items-center gap-2 ml-4">
          <input
            type="date"
            value={customRange?.start}
            onChange={(e) =>
              setCustomRange({ ...customRange, start: e?.target?.value })
            }
            className="px-3 py-2 border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
          <span className="text-muted-foreground">to</span>
          <input
            type="date"
            value={customRange?.end}
            onChange={(e) =>
              setCustomRange({ ...customRange, end: e?.target?.value })
            }
            className="px-3 py-2 border border-input rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-ring"
          />
          <button
            onClick={handleCustomRangeApply}
            className="px-4 py-2 bg-primary text-primary-foreground rounded-md text-sm font-medium hover:opacity-90 transition-opacity"
          >
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default DateRangeSelector;